import { render, staticRenderFns } from "./BorderlessDropdown.vue?vue&type=template&id=0b2ed858"
import script from "./BorderlessDropdown.vue?vue&type=script&lang=ts"
export * from "./BorderlessDropdown.vue?vue&type=script&lang=ts"
import style0 from "./BorderlessDropdown.vue?vue&type=style&index=0&id=0b2ed858&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports